<!-- 选择车系 -->
<template>
    <div id="chooseCarType">
        <div class="tabs-btn-ctn">
            <div class="tab-btn-item" @click="tabToggle(0)" :class="{'tab-active':tabInd == 0}">选择车型</div>
            <div class="tab-btn-item" @click="tabToggle(1)" :class="{'tab-active':tabInd == 1}">车系搜索</div>
        </div>
        <div class="nomal-tabs-content">
            <div class="nomal-tab-section" v-show="tabInd == 0 ">
                <!-- 步骤条 -->
                <div class="choose-progress">
                    <el-steps :active="active" simple>
                        <el-step title="选择品牌"></el-step>
                        <el-step title="选择车系"></el-step>
                        <!--<el-step title="选择排量"></el-step>-->
                        <!--<el-step title="生产年份"></el-step>-->
                        <!--<el-step title="选择车型"></el-step>-->
                    </el-steps>
                </div>
                <div class="choosed">
                    <span>已选品牌：</span>
                    <span :key="index" v-for="(item,index) in choosedData" class="choose-item" v-show="index != 4">
                        {{item}}
                        <i class="el-icon-close" @click="reChoose(index)"></i>
                        </span>
                </div>
                <!--选择品牌-->
                <div v-show="active == 0 ">
                    <div class="car-sort">
                        <div :class="['sort-item',nowInitials== -1 ?'active':'']" @click='typeToggle(-1)'>
                            热门品牌
                        </div>
                        <div :key="key" :class="['sort-item',nowInitials== key?'active':'']"
                             v-for="(value,key) in brand"
                             @click='typeToggle(key)'
                        >
                            {{key}}
                        </div>
                    </div>
                    <div class="car-ctn">
                        <template v-if="nowCarType && nowCarType[0]">
                            <div :key="index" v-for="(item,index) in nowCarType" class="car-item">
                                <img :src="QN_URL_BASE+item.Logo" alt="" class="car-logo" :onerror="defaultImg">
                                {{item.Cn}}
                                <div class="choose-ops">
                                    <div @click="returnPP(item)">选择品牌</div>|<div @click="choosePP(item)">细分车系</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="no-data">
                                暂无数据
                            </div>
                        </template>

                    </div>
                </div>
                <!--选择车系-->
                <div v-show="active == 1" class="sp-ctn">
                    <div :key="key" v-for="(value,key) in carModelData">
                        <div class='car-orange'>{{key}}</div>
                        <div class="cx-ctn">
                            <div :key="index" v-for="(i,index) in value" class="sp-item" @click="chooseCx(i)">
                                {{i.AutoSerieName}}
                            </div>
                        </div>
                    </div>
                </div>
                <!--选择排量-->
                <div v-show="active == 2" class="sp-ctn">
                    <div class="pl-ctn">
                        <div :key="index" v-for="(item,index) in plData" class="sp-item" @click="choosePL(item)">
                            {{item.Emission}}
                        </div>
                    </div>
                </div>
                <!--生产年份-->
                <div v-show="active == 3" class="sp-ctn">
                    <div class="pl-ctn">
                        <div :key="index" v-for="(item,index) in nfData" class="sp-item" @click="chooseNF(item)">
                            {{item.ProducedYear}}
                        </div>
                    </div>
                </div>
                <!--选择车型-->
                <div v-show="active == 5" class="sp-ctn choose-success">
                    车型选择成功
                </div>
            </div>
            <!-- 搜索 -->
            <div class="nomal-tab-section sp-ctn" v-show="tabInd == 1 ">
                <div class="search-ctn">
                    <el-input placeholder="请输入品牌或车系" class="search-input" v-model="searchKey"></el-input>
                    <el-button slot="append" class="btn-primary" icon="el-icon-search" @click="searchCar">搜索</el-button>
                </div>
                <div :key="index" v-for="(item,index) in searchResult">
                    <div class='car-orange'>{{item.ManufacturerName}}</div>
                    <div class="cx-ctn">
                        <div :key="index2" v-for="(i,index2) in item.DetailList" class="sp-item" @click="chooseCx(i)">
                            {{i.AutoSerieName}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'chooseCarType',
        components: {

        },
        data(){
            return {
                defaultImg:'this.src="' + this.$util.DEFAULT_IMAGE + '"',
                QN_URL_BASE:this.$util.QN_URL_BASE,
                searchKey:'', // 搜索关键字
                searchResult:[],
                nowCarType:null, // 当前显示的车系
                nowInitials:'-1',  // 当前active索引
                choosedData:[], // 选中的数据
                active:0, // 步骤进度
                tabInd:0,
                nfData:[],
                plData:[], // 排量
                carModelData:{},  // 某品牌车的车系数据
                hot: [],  // 热门车型
                // 具体车型
                brand:{},
                brandId:"", //选中的品牌id
            }
        },
        mounted(){
            this.nowCarType = this.hot
            this.getData()
            this.getHotBrands()
        },
        methods:{
            returnPP(item){
                this.choosedData = []
                this.active = 0
                this.$emit('chooseCar',item)
            },
            // 重置已选项
            resetForm (){
                this.choosedData = [] // 选中的数据
                this.active = 0 // 步骤进度
            },
            // 搜索车系
            searchCar(){
                this.$util.axiosGet({
                    url:'/api/Auto/GetVehicleSeriesList',
                    data:{
                        Keyword:this.searchKey,
                    },
                }).then((response)=> {
                    this.searchResult = response.data
                }).catch((error)=>{
                });
            },
            // 返回首字母排序好的车品牌
            getData(){
                this.$util.axiosGet({
                    url:'api/Auto/GetAllAutoBrands',
                    data:this.searchData,
                })
                    .then((response)=> {
                        let data = response.data
                        delete data.hot
                        this.brand = data
                    })
                    .catch((error)=>{
                    });
            },
            // 获取热门品牌
            getHotBrands(){
                this.$util.axiosGet({
                    url:'/api/Auto/GetHotAutoBrands',
                })
                    .then((response)=> {
                        let data = response.data
                        this.hot = data
                        this.nowCarType = this.hot
                    })
                    .catch((error)=>{
                    });
            },
            //根据品牌Id获取对应生产商的所有车系
            choosePP(item){
                this.brandId=item.Id;
                this.choosedData.push(item.Cn)
                this.$util.axiosGet({
                    url:'api/Auto/GetAutoSeriesByBId',
                    data:{
                        bId:item.Id
                    }
                })
                    .then((response)=> {
                        let data = response.data
                        this.carModelData = data
                        this.active = 1;
                    })
                    .catch((error)=>{
                    });
            },
            // 根据车系的名称去获取排量数据
            chooseCx(item){
                this.choosedData = []
                this.active = 0
                let _data = {
                    Cn:item.AutoSerieName,
                    Id:item.AutoSerieId
                }

                this.$emit('chooseCar',_data)
            },
            //根据车系的名称及排量去获取车系年份数据
            choosePL(item){
                this.choosedData.push(item.Emission)
                this.$util.axiosGet({
                    url:'api/Auto/GetYearByEmissionAndSName',
                    data:{
                        sName:item.Cn,
                        Emission:item.Emission,
                        bId:this.brandId
                    }
                })
                    .then((response)=> {
                        let data = response.data
                        this.nfData = data
                        this.active = 3;
                    })
                    .catch((error)=>{
                    });

            },
            //选择年份
            chooseNF(item){
                this.choosedData.push(item.ProducedYear)
                this.choosedData.push(item.SId)
                this.active = 5;
                this.$emit('chooseCar',this.choosedData)
            },
            // 从搜索栏选车
            seatchResultClick(item,origin){
                this.tabInd = 0;
                this.choosedData = []
                this.choosedData.push(origin)
                this.choosedData.push(item.type)
                this.active = 2;
            },
            // 切换最上面的tab
            tabToggle(i) {
                this.tabInd = i;
            },
            // 点击x
            reChoose(i){
                let _choosedData = this.choosedData
                switch (i) {
                    case 0:
                        this.choosedData = []
                        this.active = 0
                        break
                    case 1:
                        this.choosedData = _choosedData.slice(0,1)
                        this.active = 1
                        break
                    case 2:
                        this.choosedData = _choosedData.slice(0,2)
                        this.active = 2
                        break
                    case 3:
                        this.choosedData = _choosedData.slice(0,3)
                        this.active = 3
                        break
                    case 4:
                        this.choosedData = _choosedData.slice(0,4)
                        this.active = 4
                        break
                }
            },
            // 切换选择品牌索引
            typeToggle(index) {
                this.nowInitials = index;
                if (index == -1){
                    this.nowCarType = this.hot
                    return
                }
                let _brand = this.brand;
                for (let key in _brand){
                    if (key == index){
                        this.nowCarType = _brand[key]
                    }
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .choose-ops {
        opacity: 0;
        position: absolute;
        top: 0;
        left:0 ;
        width: 100%;
        height: 100%;
        background: rgba(255,255,255,0.7);
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        div {
            &:hover {
                color: @theme;
            }
        }
    }
    .tabs-btn-ctn{
        border-bottom: 1px solid @border1Color;
        .tab-btn-item {
            flex-grow: 0;
            width: 120px;
            padding: 0 10px;
            border-bottom: none;
        }
    }
    .choose-progress {
        padding: 20px 20px 20px 0 ;
    }
    .choose-item {
        border: 1px solid @theme;
        padding: 5px 10px;
        margin-right: 10px;
        i {
            cursor: pointer;
        }
    }
    .car-sort {
        padding: 20px 0;
        display: flex;
    }
    .active {
        background: @theme;
        color: #fff;
    }
    .sort-item {
        padding: 5px 10px;
        font-weight: bold;
        cursor: pointer;
    }
    .car-ctn {
        display: flex;
        flex-wrap: wrap;
    }
    .car-item {
        position: relative;
        display: flex;
        align-items: center;
        width: 165px;
        height: 52px;
        border: 1px solid @border1Color;
        margin-bottom: 20px;
        margin-right: 20px;
        cursor: pointer;
        &:hover {
            border: 1px solid @theme;
            .choose-ops {
                opacity: 1;
            }
        }
    }
    .car-logo {
        width: 30px;
        height: 30px;
        margin: 0 20px 0 30px;
    }
    .sp-ctn {
        padding-top: 20px;
    }
    .car-orange {
        background: @border4Color;
        padding: 10px 20px;
        border-left:5px solid @theme ;
        margin-bottom: 10px;
    }
    .cx-ctn {
        display: flex;
        flex-wrap: wrap;
    }
    .sp-item {
        width: 162px;
        line-height: 52px;
        border: 1px solid @border4Color;
        text-align: center;
        margin: 0 10px 10px 0;
        cursor: pointer;
        &:hover {
            border: 1px solid @theme;
        }
    }
    .pl-ctn {
        display: flex;
    }
    .choose-success {
        font-size: @font-lg;
        line-height: 80px;
        text-align: center;
    }
    .search-ctn {
        height: 60px;
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
    }
    .search-input {
        width: 80%;
        margin-right: 10px;
    }
    .no-data {
        width: 100%;
        line-height: 100px;
        text-align: center;
    }
</style>
